import request from '@/utils/request'


// 查询活动关联的商品列表
export function listHuodongGoods(query) {
  return request({
    url: '/zb/huodong/goods/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询活动关联的商品分页
export function pageHuodongGoods(query) {
  return request({
    url: '/zb/huodong/goods/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询活动关联的商品详细
export function getHuodongGoods(data) {
  return request({
    url: '/zb/huodong/goods/detail',
    method: 'get',
    params: data
  })
}

// 新增活动关联的商品
export function addHuodongGoods(data) {
  return request({
    url: '/zb/huodong/goods/add',
    method: 'post',
    data: data
  })
}

// 修改活动关联的商品
export function updateHuodongGoods(data) {
  return request({
    url: '/zb/huodong/goods/edit',
    method: 'post',
    data: data
  })
}

// 删除活动关联的商品
export function delHuodongGoods(data) {
  return request({
    url: '/zb/huodong/goods/delete',
    method: 'post',
    data: data
  })
}
